import {ApiAxiosInstance, create} from "@/helpers/api";

export const auth: ApiAxiosInstance = create();

export default auth